import Skeleton from "react-loading-skeleton";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";

export function PartnerAttributionsSkeleton() {
	return (
		<div>
			<Table className="mt-8">
				<TableHead>
					<TableRow>
						<TableHeader>Install ID</TableHeader>
						<TableHeader>App</TableHeader>
						<TableHeader>Method</TableHeader>
						<TableHeader>Attributed At</TableHeader>
						<TableHeader>Total Earnings</TableHeader>
					</TableRow>
				</TableHead>
				<TableBody>
					{Array.from({ length: 5 }).map((_, i) => (
						<TableRow key={`row-${i}`}>
							<TableCell>
								<Skeleton width={120} />
							</TableCell>
							<TableCell>
								<Skeleton width={100} />
							</TableCell>
							<TableCell>
								<Skeleton width={60} borderRadius={9999} />
							</TableCell>
							<TableCell>
								<Skeleton width={140} />
							</TableCell>
							<TableCell>
								<Skeleton width={80} />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
